import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, RequireAuth } from './contexts/AuthContext';
import Dashboard from './components/Dashboard';
import { ProjectsPage } from './pages/ProjectsPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
import FactsAgentPage from './pages/FactsAgentPage';
import TopicalMapPage from './pages/TopicalMapPage';
import CPImagesPage from './pages/CPImagesPage';
import ImagesPage from './pages/ImagesPage';
import ContentPage from './pages/ContentPage';
import BriefContentPage from './pages/BriefContentPage';
import LiveUpdatePage from './pages/LiveUpdatePage';
import PayloadAgentPage from './pages/PayloadAgentPage';
import GDriveEditorPage from './pages/GDriveEditorPage';
import ContentFrameworkV2Page from './pages/ContentFrameworkV2Page';
import BahaAgentsPage from './pages/BahaAgentsPage';
import ImageGeneratorPage from './pages/ImageGeneratorPage';
import ArticleUpdatePage from './pages/ArticleUpdatePage';
import SettingsPage from './pages/SettingsPage';
import KnowledgeBasePage from './pages/KnowledgeBasePage';
import SOPTopicalMapPage from './pages/SOPTopicalMapPage';
import LoginPage from './pages/LoginPage';
import UsersPage from './pages/UsersPage';
import ProjectActivitiesPage from './pages/ProjectActivitiesPage';
import ContentWriterPage from './pages/ContentWriterPage';
import CwNonBnPage from './pages/CwNonBnPage';
import SystemMonitorPage from './pages/SystemMonitorPage';
import AgentMonitorPage from './pages/AgentMonitorPage';
import AnalyticsDashboardPage from './pages/AnalyticsDashboardPage';
import SEODashboardPage from './pages/SEODashboardPage';
import SEOClientDetailPage from './pages/SEOClientDetailPage';
import NotionDashboardPage from './pages/NotionDashboardPage';
import BrandBrainPage from './pages/BrandBrainPage';
import SocialMediaPage from './pages/SocialMediaPage';
import BrandKitPage from './pages/BrandKitPage';
import ContentFrameworkCustomPage from './pages/ContentFrameworkCustomPage';
import HolisticSEOPage from './pages/HolisticSEOPage';
import ICPAgentPage from './pages/ICPAgentPage';
import IntentVolumePage from './pages/IntentVolumePage';
import LLMVisibilityPage from './pages/LLMVisibilityPage';
import LLMBlockTestPage from './pages/LLMBlockTestPage';
import FAQInjectorPage from './pages/FAQInjectorPage';
import LLMBlockTestReportPage from './pages/LLMBlockTestReportPage';
import LiveHtmlTestPage from './pages/LiveHtmlTestPage';
import SharedContentViewerPage from './pages/SharedContentViewerPage';
import SuperAdminPage from './pages/SuperAdminPage';
import BackupLogsPage from './pages/BackupLogsPage';
import NotFoundPage from './pages/NotFoundPage';
import WebsiteAuditPage from './pages/WebsiteAuditPage';
import ContentCalendarPage from './pages/ContentCalendarPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected Routes */}
          <Route path="/" element={<RequireAuth><ProjectsPage /></RequireAuth>} />
          <Route path="/projects" element={<RequireAuth><ProjectsPage /></RequireAuth>} />
          <Route path="/projects/:projectId" element={<RequireAuth><ProjectsPage /></RequireAuth>} />

          {/* Project-specific routes */}
          <Route path="/projects/:projectId/factsagent" element={<RequireAuth><FactsAgentPage /></RequireAuth>} />
          <Route path="/projects/:projectId/icp-agent" element={<RequireAuth><ICPAgentPage /></RequireAuth>} />
          <Route path="/projects/:projectId/brand-kit" element={<RequireAuth><BrandKitPage /></RequireAuth>} />
          <Route path="/projects/:projectId/website-audit" element={<RequireAuth><WebsiteAuditPage /></RequireAuth>} />
          <Route path="/projects/:projectId/website-audit/:crawlId" element={<RequireAuth><WebsiteAuditPage /></RequireAuth>} />
          <Route path="/projects/:projectId/content-calendar" element={<RequireAuth><ContentCalendarPage /></RequireAuth>} />
          <Route path="/projects/:projectId/imagegenerator" element={<RequireAuth><ImageGeneratorPage /></RequireAuth>} />
          <Route path="/projects/:projectId/topicalmap" element={<RequireAuth><TopicalMapPage /></RequireAuth>} />
          <Route path="/projects/:projectId/sop-topicalmap" element={<RequireAuth><SOPTopicalMapPage /></RequireAuth>} />
          <Route path="/projects/:projectId/sop-topicalmap/:sopStep" element={<RequireAuth><SOPTopicalMapPage /></RequireAuth>} />
          <Route path="/projects/:projectId/content-writer" element={<RequireAuth><ContentWriterPage /></RequireAuth>} />
          <Route path="/projects/:projectId/cw-non-bn" element={<RequireAuth><CwNonBnPage /></RequireAuth>} />
          <Route path="/projects/:projectId/contentframeworkv2" element={<RequireAuth><ContentFrameworkV2Page /></RequireAuth>} />
          <Route path="/projects/:projectId/cpimages" element={<RequireAuth><CPImagesPage /></RequireAuth>} />
          <Route path="/projects/:projectId/contentframework-custom" element={<RequireAuth><ContentFrameworkCustomPage /></RequireAuth>} />
          <Route path="/projects/:projectId/briefcontent" element={<RequireAuth><BriefContentPage /></RequireAuth>} />
          <Route path="/projects/:projectId/liveupdate" element={<RequireAuth><LiveUpdatePage /></RequireAuth>} />
          <Route path="/projects/:projectId/liveupdate/:liveStep" element={<RequireAuth><LiveUpdatePage /></RequireAuth>} />
          <Route path="/projects/:projectId/payloadagent" element={<RequireAuth><PayloadAgentPage /></RequireAuth>} />
          <Route path="/projects/:projectId/gdriveeditor" element={<RequireAuth><GDriveEditorPage /></RequireAuth>} />
          <Route path="/projects/:projectId/social-media" element={<RequireAuth><SocialMediaPage /></RequireAuth>} />
          <Route path="/projects/:projectId/analytics" element={<RequireAuth><AnalyticsPage /></RequireAuth>} />
          <Route path="/projects/:projectId/activities" element={<RequireAuth><ProjectActivitiesPage /></RequireAuth>} />

          {/* Non-project-specific routes */}
          <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
          <Route path="/seo-dashboard" element={<RequireAuth><SEODashboardPage /></RequireAuth>} />
          <Route path="/seo-dashboard/:clientId" element={<RequireAuth><SEOClientDetailPage /></RequireAuth>} />
          <Route path="/holistic-seo" element={<RequireAuth><HolisticSEOPage /></RequireAuth>} />
          <Route path="/llm-visibility" element={<RequireAuth><LLMVisibilityPage /></RequireAuth>} />
          <Route path="/llm-block-test" element={<RequireAuth><LLMBlockTestPage /></RequireAuth>} />
          <Route path="/llm-block-test/report/:shareToken" element={<LLMBlockTestReportPage />} />
          <Route path="/live-html-test" element={<RequireAuth><LiveHtmlTestPage /></RequireAuth>} />
          <Route path="/projects/:projectId/faq-injector" element={<RequireAuth><FAQInjectorPage /></RequireAuth>} />
          <Route path="/faq-injector" element={<RequireAuth><FAQInjectorPage /></RequireAuth>} />
          <Route path="/brand-brain" element={<RequireAuth><BrandBrainPage /></RequireAuth>} />
          <Route path="/article-update" element={<RequireAuth><ArticleUpdatePage /></RequireAuth>} />
          <Route path="/bahaagents/:agentType" element={<RequireAuth><BahaAgentsPage /></RequireAuth>} />
          <Route path="/intent-volume" element={<RequireAuth><IntentVolumePage /></RequireAuth>} />
          <Route path="/settings" element={<RequireAuth><SettingsPage /></RequireAuth>} />
          <Route path="/knowledgebase" element={<RequireAuth><KnowledgeBasePage /></RequireAuth>} />

          {/* Legacy routes (for backwards compatibility) - redirect to project-specific */}
          <Route path="/factsagent" element={<RequireAuth><FactsAgentPage /></RequireAuth>} />
          <Route path="/icp-agent" element={<RequireAuth><ICPAgentPage /></RequireAuth>} />
          <Route path="/brand-kit" element={<RequireAuth><BrandKitPage /></RequireAuth>} />
          <Route path="/website-audit" element={<RequireAuth><WebsiteAuditPage /></RequireAuth>} />
          <Route path="/imagegenerator" element={<RequireAuth><ImageGeneratorPage /></RequireAuth>} />
          <Route path="/topicalmap" element={<RequireAuth><TopicalMapPage /></RequireAuth>} />
          <Route path="/sop-topicalmap" element={<RequireAuth><SOPTopicalMapPage /></RequireAuth>} />
          <Route path="/content-writer" element={<RequireAuth><ContentWriterPage /></RequireAuth>} />
          <Route path="/cw-non-bn" element={<RequireAuth><CwNonBnPage /></RequireAuth>} />
          <Route path="/contentframeworkv2" element={<RequireAuth><ContentFrameworkV2Page /></RequireAuth>} />
          <Route path="/cpimages" element={<RequireAuth><CPImagesPage /></RequireAuth>} />
          <Route path="/contentframework-custom" element={<RequireAuth><ContentFrameworkCustomPage /></RequireAuth>} />
          <Route path="/briefcontent" element={<RequireAuth><BriefContentPage /></RequireAuth>} />
          <Route path="/liveupdate" element={<RequireAuth><LiveUpdatePage /></RequireAuth>} />
          <Route path="/payloadagent" element={<RequireAuth><PayloadAgentPage /></RequireAuth>} />
          <Route path="/gdriveeditor" element={<RequireAuth><GDriveEditorPage /></RequireAuth>} />
          <Route path="/social-media" element={<RequireAuth><SocialMediaPage /></RequireAuth>} />
          <Route path="/analytics" element={<RequireAuth><AnalyticsDashboardPage /></RequireAuth>} />
          <Route path="/analytics/:projectId" element={<RequireAuth><AnalyticsPage /></RequireAuth>} />

          {/* Public Sharing Route */}
          <Route path="/share/:shareId" element={<SharedContentViewerPage />} />

          {/* Admin Only Routes */}
          <Route path="/users" element={<UsersPage />} />
          <Route path="/system-monitor" element={<RequireAuth><SystemMonitorPage /></RequireAuth>} />
          <Route path="/agent-monitor" element={<RequireAuth><AgentMonitorPage /></RequireAuth>} />
          <Route path="/seo-dashboard" element={<RequireAuth><SEODashboardPage /></RequireAuth>} />
          <Route path="/seo-dashboard/:clientId" element={<RequireAuth><SEOClientDetailPage /></RequireAuth>} />
          <Route path="/notion-dashboard" element={<RequireAuth><NotionDashboardPage /></RequireAuth>} />
          <Route path="/notion-dashboard/onboarding-automation" element={<RequireAuth><NotionDashboardPage /></RequireAuth>} />
          <Route path="/notion-dashboard/people-workload" element={<RequireAuth><NotionDashboardPage /></RequireAuth>} />
          <Route path="/notion-dashboard/notion-api-automation" element={<RequireAuth><NotionDashboardPage /></RequireAuth>} />
          <Route path="/super-admin" element={<RequireAuth><SuperAdminPage /></RequireAuth>} />
          <Route path="/backup-logs" element={<RequireAuth><BackupLogsPage /></RequireAuth>} />

          {/* 404 - Catch all unmatched routes */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
